<template>
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    aria-hidden="true"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.25 19.72c.41.37 1.09.37 1.5 0l7.94-7.1a.88.88 0 0 0 0-1.34 1.15 1.15 0 0 0-1.5 0L15 17.7l-7.2-6.43a1.15 1.15 0 0 0-1.49 0 .88.88 0 0 0 0 1.34l7.94 7.1Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
